import { render, staticRenderFns } from "./obligee.vue?vue&type=template&id=41edc11d&scoped=true&"
import script from "./obligee.vue?vue&type=script&lang=js&"
export * from "./obligee.vue?vue&type=script&lang=js&"
import style0 from "./obligee.vue?vue&type=style&index=0&lang=less&"
import style1 from "./obligee.vue?vue&type=style&index=1&id=41edc11d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41edc11d",
  null
  
)

export default component.exports